// ES5 module syntax for expose-loader compatability

const CalcRulesLib = require("../es").default;

module.exports = CalcRulesLib;
